<template>
  <div>
    <div class="preview-content">
      <vue-pdf-embed
        ref="pdfRef"
        :source="pdfSource || defaults.pdfSource"
        :page="page"
        @rendered="handleDocumentRender"
        />
    <div class="preview-btns">
      <b-button pill variant="outline-secondary" :disabled="page <= 1" @click="page--">❮</b-button>
      {{ `${page} / ${pageCount}` }}
      <b-button pill variant="outline-secondary" :disabled="page >= pageCount" @click="page++">❯</b-button>
      </div>
    </div>
  </div>
</template>

<script>
let VuePdfEmbed;
if (process.env.VUE_ENV !== 'server') {
  const pdfEmbed = require('vue-pdf-embed/dist/vue2-pdf-embed');
  VuePdfEmbed = pdfEmbed.default;
} else {
  VuePdfEmbed = {
    render: h => h('div'),
  };
}

export default {
  props: {
    pdfSource: String,
    default: 'https://real-links-assets-dev.s3-eu-west-2.amazonaws.com/real-links-WK80K/2024-10-10/01J9VFCFY15FX2H5YGEM9M9RBQ/default-pdf.pdf'
  },
  components: {
    VuePdfEmbed
  },
  data() {
    return {
      page: 1,
      pageCount: 1,
    };
  },
  computed: {
    defaults() {
      return {
        pdfSource: 'https://real-links-assets-dev.s3-eu-west-2.amazonaws.com/real-links-WK80K/2024-10-10/01J9VFCFY15FX2H5YGEM9M9RBQ/default-pdf.pdf',
      };
    },
  },
  methods: {
    handleDocumentRender() {
      this.pageCount = this.$refs.pdfRef.pageCount;
    },
  }
};
</script>

<style lang="scss">
.vue-pdf-embed > div {
  margin-bottom: 8px;
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}

.preview-btns {
  padding-top: 16px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.preview-content {
  margin: 24px 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/content-share/PdfPreview.vue